"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 54.78 24",
    width: "54.78",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m54 15.2h-3.25v-14.4a.8.8 0 0 0 -.75-.8h-45.16a.8.8 0 0 0 -.84.8v14.4h-3.19a.78.78 0 1 0 0 1.56h3.3a3.92 3.92 0 1 0 4.05 0h3.84a3.91 3.91 0 1 0 6 3.33 4 4 0 0 0 -.08-.78.8.8 0 0 0 .75.52h17.22a.79.79 0 0 0 .65-.36 4.2 4.2 0 0 0 -.06.62 3.91 3.91 0 1 0 5.93-3.33h3.87a3.91 3.91 0 1 0 4.06 0h3.66a.78.78 0 1 0 0-1.56zm-5.66 2.53a2.36 2.36 0 1 1 -2.34 2.36 2.36 2.36 0 0 1 2.31-2.36zm-42.74-16.16h43.59v13.63h-8.13v-5.53a.78.78 0 1 0 -1.56 0v5.53h-24.22v-5.53a.78.78 0 1 0 -1.56 0v5.53h-8.12zm34.79 16.16a2.36 2.36 0 1 1 -2.39 2.36 2.36 2.36 0 0 1 2.39-2.36zm-24 2.36a2.36 2.36 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.37 2.36zm-10.25-2.36a2.36 2.36 0 1 1 -2.35 2.36 2.36 2.36 0 0 1 2.35-2.36zm9.94-1h1.75v2.27a.75.75 0 0 0 .05.26 3.88 3.88 0 0 0 -1.8-2.5zm20.61 0h1.68a3.87 3.87 0 0 0 -1.68 2.11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m21.91 2.9h10.96v10.96h-10.96z",
    fill: "00000"
  }));
};

exports["default"] = _default;